<div class="mp-header">
  <button class="filter-btn" (click)="toggleView()">
    @if (isOverview) {
      <app-app-string key_name="golf.scorecard.matchplay.filter.details"></app-app-string>
    } @else {
      <app-app-string key_name="golf.scorecard.matchplay.filter.overview"></app-app-string>
    }
  </button>

  <button class="info-btn" mat-icon-button aria-label="Scorecard info" (click)="openInfoDialog($event)">
    <mat-icon>info</mat-icon>
  </button>
</div>

<section class="mp-card" (click)="$event.stopPropagation()">
  <table cellspacing="0" cellpadding="0">
    <colgroup>
    <col class="label-col" />
    <col class="hole-col" span="18" />
  </colgroup>

  <tbody>
    <tr class="head">
      <th class="label"><app-app-string key_name="golf.hole"></app-app-string></th>
      @for (h of holes; track h; let i = $index) {
        <th>
          @switch (holeWinner(i)) {
            @case ('eu') {
              <span class="hole-marker eu">{{ h }}</span>
            }
            @case ('us') {
              <span class="hole-marker us">{{ h }}</span>
            }
            @case ('team1') {
              <span class="hole-marker team1">{{ h }}</span>
            }
            @case ('team2') {
              <span class="hole-marker team2">{{ h }}</span>
            }
            @default {
              <span [class.hole-marker]="isFinished && isHoleNotPlayed(i)" [class.np]="isFinished && isHoleNotPlayed(i)">{{ h }}</span>
            }
          }
        </th>
      }
    </tr>

    <tr>
      <th class="label"><app-app-string key_name="golf.par"></app-app-string></th>
      @for (h of holes; track h; let i = $index) {
        <td>{{ parAt(i) }}</td>
      }
    </tr>

    @if (!isOverview) {
      @if (isFoursomes) {
        <tr>
          <th class="label">
            <div class="team-label">
              @for (p of teamPlayers('left'); track p) {
                <div>
                  <span class="fit">
                    {{ shortName(p) }}
                  </span>
                </div>
              }
            </div>
          </th>
          @for (h of holes; track h; let i = $index) {
            <td>
              <span class="score" [ngClass]="mergeClasses(getTeamCellClasses('left', i))">
                {{ teamScoreAt('left', i) }}
              </span>
            </td>
          }
        </tr>
      } @else {
        @for (lp of left; track lp) {
          <tr>
            <th class="label">
              <span class="fit">
                {{ shortName(lp.player) }}
              </span>
            </th>
            @for (h of holes; track h; let i = $index) {
              <td>
                <span class="score" [ngClass]="mergeClasses(getCellClasses('left', lp, i))">
                  {{ scoreAt(lp, i) }}
                </span>
              </td>
            }
          </tr>
        }
      }
    }

    <tr class="score-row">
      <th class="label"><app-app-string key_name="golf.scorecard.score"></app-app-string></th>
      @for (h of holes; track h; let i = $index) {
        <td>
          <span
            class="score-box"
            [class.eu]="leaderColor(i) === 'eu'"
            [class.us]="leaderColor(i) === 'us'"
            [class.team1]="leaderColor(i) === 'team1'"
            [class.team2]="leaderColor(i) === 'team2'"
            >
            {{ scoreLabel(i) }}
          </span>
        </td>
      }
    </tr>

    @if (!isOverview) {
      @if (isFoursomes) {
        <tr>
          <th class="label">
            <div class="team-label">
              @for (p of teamPlayers('right'); track p) {
                <div>
                  <span class="fit">
                    {{ shortName(p) }}
                  </span>
                </div>
              }
            </div>
          </th>
          @for (h of holes; track h; let i = $index) {
            <td>
              <span class="score" [ngClass]="mergeClasses(getTeamCellClasses('right', i))">
                {{ teamScoreAt('right', i) }}
              </span>
            </td>
          }
        </tr>
      } @else {
        @for (rp of right; track rp) {
          <tr>
            <th class="label">
              <span class="fit" appAutoFitText>
                {{ shortName(rp.player) }}
              </span>
            </th>
            @for (h of holes; track h; let i = $index) {
              <td>
                <span class="score" [ngClass]="mergeClasses(getCellClasses('right', rp, i))">
                  {{ scoreAt(rp, i) }}
                </span>
              </td>
            }
          </tr>
        }
      }
    }
  </tbody>
</table>

@if ((extraAggregate?.length || 0) > 0) {
  <app-matchplay-playoff-table
    [left]="left"
    [right]="right"
    [extraAggregate]="extraAggregate"
    [gameType]="gameType"
    [isOverview]="isOverview"
    >
  </app-matchplay-playoff-table>
}
</section>
